import { Component, computed, input, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ZiroFieldComponentConfig } from '../../../ziro-forms-models';
import { ZiroFieldAbstractDirective } from '../../../ziro-field-abstract.directive';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { NgClass } from '@angular/common';

export class ZiroTimeSelectConfig extends ZiroFieldComponentConfig {}

@Component({
  selector: 'ziro-time-select',
  templateUrl: './ziro-time-select.component.html',
  styleUrl: './ziro-time-select.component.scss',
  standalone: true,
  imports: [FormsModule, PipesModule, NgClass],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: ZiroTimeSelectComponent }],
})
export class ZiroTimeSelectComponent extends ZiroFieldAbstractDirective<string, string, ZiroTimeSelectConfig> {
  @Input() isFormSubmitted: boolean;

  intervalMinutes = input<number | null>(null);

  hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
  periods = ['AM', 'PM'] as const;

  selectedHour = '';
  selectedMinute = '';
  selectedPeriod: 'AM' | 'PM' | '' = '';

  minuteOptions = computed(() => {
    const interval = this.intervalMinutes();
    if (!interval) {
      return Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));
    }
    const options: string[] = [];
    for (let minute = 0; minute < 60; minute += interval) {
      options.push(String(minute).padStart(2, '0'));
    }
    return options;
  });

  init(): void {
    this.config = this.config ?? new ZiroTimeSelectConfig();
    super.init();
  }

  _onReceiveNewEntity = (entity: string): void => {
    this.fieldData = entity;
    this._parseValue(entity);
  };

  onSelectionChange(): void {
    if (!this.selectedHour || !this.selectedMinute || !this.selectedPeriod) {
      this.fieldData = '';
      this.updateSelf(this.fieldData);
      return;
    }

    let hour = Number(this.selectedHour);
    if (this.selectedPeriod === 'PM' && hour !== 12) {
      hour += 12;
    }
    if (this.selectedPeriod === 'AM' && hour === 12) {
      hour = 0;
    }

    this.fieldData = `${String(hour).padStart(2, '0')}:${this.selectedMinute}`;
    this.updateSelf(this.fieldData);
  }

  private _parseValue(value: string | null): void {
    if (!value) {
      this.selectedHour = '';
      this.selectedMinute = '';
      this.selectedPeriod = '';
      return;
    }

    const [hourValue, minuteValue] = value.split(':').map(Number);
    this.selectedPeriod = hourValue >= 12 ? 'PM' : 'AM';
    this.selectedHour = String(hourValue % 12 || 12).padStart(2, '0');
    this.selectedMinute = String(minuteValue).padStart(2, '0');
  }
}
